import { DatePicker, TimePicker, TimePickerProps } from 'antd';
import React, { useEffect, useState } from 'react'
import customParseFormat from "dayjs/plugin/customParseFormat";
import dayjs, { Dayjs } from "dayjs";
import Select, { StylesConfig } from "react-select";
import TextField from '../../../../core/common/textFields/TextField';
import { useGetAllActiveUsersQuery, useGetSaleInfoByIdQuery, useLazyGetSaleInfoByIdQuery, useUpsertSaleInfoDetailsMutation } from '../../../../services/EndPointsApis';
import { useFormik } from 'formik';
import { initialValuesSale } from '../../Projects/SaleWizardData/InitialValuesSalesWizard';
import Ribbon from '../../../../core/common/ribbon/ribbon';
import { toast } from 'react-toastify';
import * as Yup from "yup";
import DateComp from '../../../../core/common/dateComponent/DateComp';
import { CSVLink } from 'react-csv';
import FormattedNumber from '../../../../core/common/textFields/FormatNumber';
import TableLoading from '../../../../core/common/loadingComponent/TableLoading';
import DateTimeComp from '../../../../core/common/dateComponent/DateTimeComp';


const PaymentPaid = ({ projectId }: any) => {

    dayjs.extend(customParseFormat);

    //Get Sale Info
    const { data: saleInfoData, refetch, isFetching } = useGetSaleInfoByIdQuery({ ProjectId: projectId })
    useEffect(() => {
        refetch()
    }, []);

    const formatComma = (num: number | string) => {
        if (num === null || num === undefined) return "0.0";
        const numericValue = String(num).replace(/,/g, "");
        if (isNaN(Number(numericValue))) return String(num);
        return Number(numericValue).toLocaleString();
    };

    const totalAmount = saleInfoData?.result?.projectPaymentPayableList?.projectPaymentPayable?.reduce((sum: any, item: any) =>
        sum + (item?.amount || 0),
        0
    ) || 0

    const totalCount = saleInfoData?.result?.projectPaymentPayableList?.projectPaymentPayable?.reduce((sum: any, item: any) =>
        sum + 1,
        0
    ) || 0

    const formatNumber = (value: any) =>
        value ? new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(Number(value)) : "0.00";

    const headers = [
        { label: "Date", key: "dateCreatedInTB" },
        { label: "Vendor", key: "vendorName" },
        { label: "Payment Description", key: "description" },
        { label: "Category", key: "categoryName" },
        { label: "Phase", key: "phaseName" },
        { label: "Amount", key: "amount" }
    ];
    const formatDate = (date?: any | null) => {
        if (!date) return "";
        const d = dayjs(date);
        return d.isValid() ? d.format("MMM/DD/YYYY") : "";
    };
    const csvData = saleInfoData?.result?.projectPaymentPayableList?.projectPaymentPayable?.map((item: any) => ({
        dateCreatedInTB: formatDate(item.transcationDate),
        vendorName: item.vendorName,
        description: item.description,
        categoryName: item.categoryName,
        phaseName: item.phaseName,
        amount: formatComma(item.amount ?? '0.0')
    })) || [];
    return (
        <>
            <div className='row'>
                <div className='col-md-10'>
                    {/* table  */}
                    <div className='card'>
                        <div className='card-body card-css'>
                            <div className='d-flex'>
                                <div className='w-35'>
                                    <p className='mb-0'>Last Timberline Sync: </p>
                                </div>
                                <div>
                                    {' '}  <DateTimeComp formattedDate={saleInfoData?.result?.projectPaymentPayableList?.lstTimberLineSync} />
                                </div>
                            </div>
                            <div className='d-flex'>
                                <div className='w-35'>
                                    <p className='mb-0'>Last AP entry in Timberline: </p>
                                </div>
                                <div>
                                    {''}  <DateTimeComp formattedDate={saleInfoData?.result?.projectPaymentPayableList?.lstApEntryInTimberLine} />
                                </div>
                            </div>
                            <div className='d-flex justify-content-end'>
                                <CSVLink data={csvData} headers={headers} filename={`Payment Paid.csv`} className="btn btn-light-red d-flex justify-content-center gap-1 align-items-center">
                                    <i className="fa fa-file-export" />
                                    Export To CSV
                                </CSVLink>
                            </div>
                            <div className="table-responsive mt-2 overflow-auto paymentPaidHeight">
                                <table className="table datanew dataTable no-footer table-hover">
                                    <thead>
                                        <tr>
                                            <th>
                                                Date
                                            </th>
                                            <th>
                                                Vendor
                                            </th>
                                            <th>
                                                Payment Description
                                            </th>
                                            <th>
                                                Category
                                            </th>
                                            <th>
                                                Phase
                                            </th>
                                            <th className='text-end'>
                                                Amount
                                            </th>
                                        </tr>
                                    </thead>
                                    {isFetching ?
                                        <tr>
                                            <td colSpan={5} className='text-center'>
                                                <TableLoading />
                                            </td>
                                        </tr>
                                        :
                                        <tbody>
                                            {saleInfoData?.result?.projectPaymentPayableList?.projectPaymentPayable?.map((item: any, index: any) => (
                                                <tr key={item.id}>
                                                    <td><DateComp formattedDate={item?.transcationDate} /></td>
                                                    <td className=''>{item?.vendorName}</td>
                                                    <td>{item?.description}</td>
                                                    <td>{item?.categoryName}</td>
                                                    <td>{item?.phaseName}</td>
                                                    <td className='text-end'>
                                                        <FormattedNumber value={item.amount} />
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    }

                                </table>
                            </div>
                            <div className='row'>
                                <div className='col-md-5 pt-4 text-end'>
                                    <h6 className='color-red'> Count :{totalCount}</h6>
                                </div>
                                <div className='col-md-7 pt-4 text-end'>
                                    <h6 className='color-red mr-15'><FormattedNumber value={totalAmount} /></h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>

    )
}

export default PaymentPaid